/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { BrokerResponseDto } from './BrokerResponseDto';
import {
    BrokerResponseDtoFromJSON,
    BrokerResponseDtoFromJSONTyped,
    BrokerResponseDtoToJSON,
    BrokerResponseDtoToJSONTyped,
} from './BrokerResponseDto';

/**
 * 
 * @export
 * @interface BrokerPaginationResponseDto
 */
export interface BrokerPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof BrokerPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<BrokerResponseDto>}
     * @memberof BrokerPaginationResponseDto
     */
    items: Array<BrokerResponseDto>;
}

/**
 * Check if a given object implements the BrokerPaginationResponseDto interface.
 */
export function instanceOfBrokerPaginationResponseDto(value: object): value is BrokerPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BrokerPaginationResponseDtoFromJSON(json: any): BrokerPaginationResponseDto {
    return BrokerPaginationResponseDtoFromJSONTyped(json, false);
}

export function BrokerPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrokerPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(BrokerResponseDtoFromJSON)),
    };
}

export function BrokerPaginationResponseDtoToJSON(json: any): BrokerPaginationResponseDto {
    return BrokerPaginationResponseDtoToJSONTyped(json, false);
}

export function BrokerPaginationResponseDtoToJSONTyped(value?: BrokerPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(BrokerResponseDtoToJSON)),
    };
}

